// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__14NPN","inner":"Form_inner__yZh0O","range":"Form_range__C8EDs","name":"Form_name__18X0j","actions":"Form_actions__2ud0E"};